module.exports = __webpack_public_path__ + "img/Still-Thinking-1-mobile.2fa630e9.png";